import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { Href } from "../../../../../Utils/Constants";
import { useLetterBoxFilter } from "../../../../../Features/letterBox/context/FilterContext";

type MailPaginationProps = {
  n_pages: number;
};

export default function MailPagination({ n_pages }: MailPaginationProps) {
  const { filters, setSelectNumber } = useLetterBoxFilter();
  const currentPage = filters.selectNumber || 1;

  if (n_pages <= 1) return null; // niente paginazione se c'è solo 1 pagina

  const handleSelect = (event: React.MouseEvent<HTMLAnchorElement>, page: number) => {
    event.preventDefault();
    if (page < 1 || page > n_pages || page === currentPage) return;
    setSelectNumber(page);
  };

  const handlePrevious = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (currentPage > 1) {
      setSelectNumber(currentPage - 1);
    }
  };

  const handleNext = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (currentPage < n_pages) {
      setSelectNumber(currentPage + 1);
    }
  };

  const getVisiblePages = (current: number, total: number): (number | "...")[] => {
    // se poche pagine, mostro tutto
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const pages: (number | "...")[] = [];

    const firstPage = 1;
    const lastPage = total;

    // sempre la prima
    pages.push(firstPage);

    // calcolo finestra centrale (max 5 pagine)
    let start = current - 2;
    let end = current + 2;

    if (start < 2) {
      start = 2;
      end = start + 4;
    }

    if (end > total - 1) {
      end = total - 1;
      start = end - 4;
    }

    // ellissi dopo la prima se c'è buco
    if (start > 2) {
      pages.push("...");
    }

    // pagine centrali
    for (let p = start; p <= end; p++) {
      pages.push(p);
    }

    // ellissi prima dell'ultima se c'è buco
    if (end < total - 1) {
      pages.push("...");
    }

    // sempre l'ultima
    pages.push(lastPage);

    return pages;
  };

  const visiblePages = getVisiblePages(currentPage, n_pages);
  const showArrows = n_pages > 3;

  return (
    <Pagination className="mail-pagination pagination-primary">
      {/* PREVIOUS */}
      {showArrows && (
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink href={Href} previous onClick={handlePrevious} />
        </PaginationItem>
      )}

      {/* NUMERI + ELLISSI */}
      {visiblePages.map((p, idx) =>
        p === "..." ? (
          <PaginationItem key={`dots-${idx}`} disabled>
            <PaginationLink href={Href}>…</PaginationLink>
          </PaginationItem>
        ) : (
          <PaginationItem
            key={p}
            active={currentPage === p}
          >
            <PaginationLink href={Href} onClick={(event) => handleSelect(event, p)}>
              {p}
            </PaginationLink>
          </PaginationItem>
        )
      )}

      {/* NEXT */}
      {showArrows && (
        <PaginationItem disabled={currentPage === n_pages}>
          <PaginationLink href={Href} next onClick={handleNext} />
        </PaginationItem>
      )}
    </Pagination>
  );
}
